// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"4b5d81b7","239":"502c42c5","316":"36d34210","574":"8c264fda","732":"5d92bf0d","762":"5d15c5cb","977":"96018b9a"}[chunkId] + ".chunk.js";
};